module.exports = __webpack_public_path__ + "img/closed-downArrow.30dab4d2.svg";